import { useEffect, useRef } from 'react'
import { routes } from '@shared/constants/routes'
import { useUser } from '@/features/account/services/User/hooks'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'
import { type PageRouteData } from '@/features/shared/utils/setPageProps'
import { usePathWithSearch } from '@/features/shared/hooks/routes/usePathWithSearch'
import { usePathname } from 'next/navigation'
import { isGatedRoute } from '@shared/constants/accessLevel'
import { useZipUserStore } from '@/features/shop/services/ShoppingStore/hooks'

export const useRoutingFlow = (routeData: PageRouteData) => {
  const user = useUser()
  const router = useSegwayRouter()
  const pathname = usePathname() ?? ''
  const pathWithSearch = usePathWithSearch()
  const zipUserStore = useZipUserStore()
  const checkedPathname = useRef<string | null>(null)

  const isUserLoaded = Boolean(user?.id)
  const requireGlobalHomepage =
    isUserLoaded && routeData?.storeRequired && !user?.store_location_id && !zipUserStore?.id

  const { isSessionValid, isSessionLoading } = useSession()

  useEffect(() => {
    if (checkedPathname.current === pathname) return
    if (isUserLoaded || (!isSessionLoading && !isSessionValid)) {
      checkedPathname.current = pathname
    }

    if (isGatedRoute(routeData?.access) && requireGlobalHomepage) {
      router.replace(`${routes.GLOBAL_HOMEPAGE.url}?next=${encodeURIComponent(pathWithSearch)}`)
    }
  }, [
    pathname,
    isUserLoaded,
    requireGlobalHomepage,
    router,
    pathWithSearch,
    isSessionLoading,
    isSessionValid,
    routeData?.access,
  ])
}
